import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import "./index.css";
import { AlertProvider } from "./context/AlertContext";

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <AlertProvider>
      <App />
      </AlertProvider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
